import React from "react";
import { PropertyValue } from "../../../shared/models/metadata.model";
import { useStoredItem } from "../../../state/InternalContext";
import { useParser } from "../../../state/parser-hook";

interface ItemPropertyProps {
    item: string,
    category: string,
    property: string,
    format?: string,
}

/***
 * A source component that returns a property of a stored item.
 * 
 * Params:
 *      store: The name of the store
 *      property: The name of the property to return
 */
export const ItemProperty = React.memo(function ItemProperty({ item, category, property, format }: ItemPropertyProps): React.ReactElement {
    const parser = useParser();
    const storedItem = useStoredItem(item);
    const props = storedItem?.props?.[category]?.[property];
    let value: PropertyValue = "";
    const normalizedFormat = format?.toLowerCase();
    if (props?.length) {
        value = props[0];
    }
    if (normalizedFormat === "number" && value instanceof Date) {
        return <>{value.getTime()}</>;
    }
    if (normalizedFormat === "html") {
        return <>{parser(value.toString().trim())}</>;
    }
    return <>{value.toString().trim()}</>;
});